import DataViewLoader from './DataViewLoader';
import { Search } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { useMemo, useState } from 'react';
import { invoiceIdFilter } from '../../util/helpers';

interface DataViewProps {
    loading: boolean;
    records: Array<RentalRequest>;
    onClick?: (data: any) => void
}

function RentalDataView({records, loading, onClick}: DataViewProps) {
  const [searchQuery, setSearchQuery] = useState('');


  const filteredRecords = useMemo(() => {
    return records.filter(invoiceIdFilter(searchQuery));
  }, [searchQuery, records]);

  const handleClick = (data: any) => {
    onClick!(data)
  }

  const hasRecords = records.length > 0 && !loading;
  const emptyRecords = !records.length && !loading;

  return (
    <div>
      <div className="w-full p-1 mb-3">
        <div className="relative">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400" />
          <Input
            type="search"
            placeholder="Search"
            className="w-full pl-8 h-9 rounded-md border-x-0 border border-gray-200 !ring-gray-200"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>
      <div className="space-y-3 p-1">
          {hasRecords && filteredRecords.map((record, index) => (<div key={index} className="grid grid-cols-2 p-6 border border-gray-200 rounded-md shadow" onClick={() => handleClick(record)}>
            <div
                className="flex items-center mb-3"
              >
                <div className="flex flex-col gap-1">
                    <span className="font-light text-400 text-sm">Trip Route</span>
                    <div className="flex flex-col gap-2">
                        <span className="text-sm font-semibold">
                            {record?.pickupAddress}
                        </span>
                        <span className="text-sm font-semibold">
                            {record?.dropoffAddress}
                        </span>
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-end text-right mb-3">
                <div className="flex flex-col gap-1">
                    <span className="text-sm font-semibold">
                        {record.invoiceId}
                    </span>
                    <div className="flex flex-col gap-2">
                        <span className="text-sm">
                            Trips
                        </span>
                        <span className="text-sm font-semibold">
                            {record?.noOfTrips}
                        </span>
                    </div>
                </div>
            </div>
            <div className="flex items-center mb-3">
                <div className="flex flex-col gap-1">
                    <span>Renter</span>
                    <div className="flex flex-col gap-2">
                        <span className="text-sm font-semibold">
                            {record?.renterName}
                        </span>
                    </div>
                </div>
            </div>            
            <div className="flex justify-end text-right items-center mb-3">
                <div className="flex flex-col gap-1">
                    <span className="text-sm">Material</span>
                    <div className="flex flex-col gap-2">
                        <span className="text-sm font-semibold">
                            {record?.material}
                        </span>
                    </div>
                </div>
            </div>            
          </div>
        ))}
      </div>
      {emptyRecords && (<p className="text-center">No Data Found</p>)}
      {loading && (<DataViewLoader />)}
    </div>
  )
}

export default RentalDataView